import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/hire-a-helper': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M443.1 0H71.9C67.9 37.3 37.4 67.8 0 71.7V443.2C37.4 448.1 66 475.6 71.9 512H444.1C447.1 475.6 476.6 446.2 512 442.2V71.7C475.6 65.8 447 36.4 443.1 0zM406.1 404.9C369.8 404.9 387.3 402.9 351 402.9 315.2 402.9 330 404.9 294.9 404.9 289 404.9 290 396.7 294.9 395.1 317.7 387.5 317.8 384.9 319.5 382.3 329.9 366.7 325.4 299.3 325.4 269.3 325.4 264 319 256.5 311.6 256.5H200.4C193 256.5 186.6 264 186.6 269.3 186.6 299.3 182.1 366.7 192.5 382.3 194.2 384.8 194.3 387.5 217.1 395.1 222 396.7 223.1 404.9 217.1 404.9 182 404.9 196.8 402.9 161 402.9 124.7 402.9 142.2 404.9 105.9 404.9 98 404.9 100.1 394.1 105.9 394.1 116.1 390.7 119.4 390.6 127.6 380.3 135.3 367.4 135.5 335.9 135.5 252.5V151.3C135.5 129.1 123.3 123 106.9 118.9 98.1 116.7 102.9 107.1 107.9 107.1 144.4 107.1 128.5 109.1 165 109.1 197.7 109.1 181.5 107.1 214.2 107.1 217.5 107.1 222.7 115.4 215.2 117.9 210.3 119.5 187.6 121.6 187.6 157.2 187.6 202.8 187.4 213 188.6 226 188.6 227.3 190.9 238.8 201.4 238.8H310.6C321.1 238.8 323.4 227.3 323.4 226 324.6 213 324.4 202.8 324.4 157.2 324.4 121.6 301.7 119.5 296.8 117.9 289.3 115.4 294.5 107.1 297.8 107.1 330.5 107.1 314.3 109.1 347 109.1 383.5 109.1 367.6 107.1 404.1 107.1 409 107.1 414 116.7 405.1 118.9 388.7 123 376.5 129.2 376.5 151.3V252.5C376.5 335.9 376.6 367.4 384.4 380.3 392.6 390.5 395.8 390.7 406.1 394.1 411.9 394.1 413.9 404.9 406.1 404.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/hire-a-helper.js
// module id = JyqY
// module chunks = 144